module.exports = __webpack_public_path__ + "assets/images/frame-br.3679cdfff7beb02ff9050f7fec062335.png";